import { McAction } from '../IMcAction';
import initialState, { IApprovedQcPlanState } from '../modules/qc-plan/IApprovedQcPlanState';
import { GET_APPROVED_QC_PLAN } from '../modules/qc-plan/qc-plan.action.const';
import { getApprovedQcPlanState } from '../modules/qc-plan/qc-plan.reducer.logic';

export function approvedQcPlanReducer(state: IApprovedQcPlanState = initialState, action: McAction) {
    switch (action.type) {
        case GET_APPROVED_QC_PLAN:
            return getApprovedQcPlanState(state, action);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/reducers/approved-qc-plan.reducer.ts